import React, { Fragment, useState } from 'react'
import { Spinner } from 'react-bootstrap';
import { Link } from 'react-router-dom';

import Product from './Product';

const Products = ({ products, loading, getProducts, removeProduct, setSearch, onSearch }) => {
    return (
        <div className='Users'>
            <div className='main d-flex mb-3 justify-content-between'>
                <div className='search-card d-flex'>
                    <div>
                        <input onChange={({ target: { value } }) => setSearch(value)} type='text' placeholder='جستجو کنید ...' />
                    </div>
                    <div onClick={onSearch}>
                        <svg width={12} height={13} viewBox='0 0 12 13' fill='none' xmlns='http://www.w3.org/2000/svg'>
                            <path fillRule='evenodd' clipRule='evenodd' d='M5.76684 0C8.94676 0 11.5333 2.58657 11.5333 5.76649C11.5333 7.26677 10.9576 8.6351 10.0154 9.66204L11.8693 11.5121C12.0428 11.6856 12.0434 11.9663 11.8699 12.1398C11.7835 12.2274 11.6692 12.2706 11.5555 12.2706C11.4424 12.2706 11.3287 12.2274 11.2416 12.141L9.36534 10.2699C8.37833 11.0603 7.12685 11.5336 5.76684 11.5336C2.58692 11.5336 -0.000244141 8.94642 -0.000244141 5.76649C-0.000244141 2.58657 2.58692 0 5.76684 0ZM5.76684 0.888246C3.07664 0.888246 0.888002 3.07629 0.888002 5.76649C0.888002 8.4567 3.07664 10.6453 5.76684 10.6453C8.45645 10.6453 10.6451 8.4567 10.6451 5.76649C10.6451 3.07629 8.45645 0.888246 5.76684 0.888246Z' fill='#666666' />
                        </svg>
                    </div>
                </div>
                <div className='filter-card'>
                    <button type="button">
                        <Link to="/panel/admin/addProduct" className='d-flex align-items-center'>
                            <span>افزودن محصول</span>
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" width={18} height={18}>
                                <path d="M400 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zm-32 252c0 6.6-5.4 12-12 12h-92v92c0 6.6-5.4 12-12 12h-56c-6.6 0-12-5.4-12-12v-92H92c-6.6 0-12-5.4-12-12v-56c0-6.6 5.4-12 12-12h92v-92c0-6.6 5.4-12 12-12h56c6.6 0 12 5.4 12 12v92h92c6.6 0 12 5.4 12 12v56z" />
                            </svg>
                        </Link>
                    </button>
                </div>
            </div>
            <table className='w-100 contact mb-3 user-card'>
                <thead className=' w-100'>
                    <tr className='d-flex align-items-center justify-content-around'>
                        <th className='text-center'>#</th>
                        <th className='text-center'>نام محصول</th>
                        <th className='text-center'>نام دسته بندی</th>
                        <th className='text-center'>کد محصول</th>
                        <th className='text-center'>موجود/ناموجود</th>
                        <th className='text-center'>عملیات</th>
                    </tr>
                </thead>
            </table>
            <div className="users">
                {loading ? <div className='d-flex align-items-center justify-content-center'> <Spinner animation='border' /> </div> :
                    products?.data?.map((product, i) => {
                        return <Product {...product} key={i} product={product} removeProduct={removeProduct} />
                    })
                }
            </div>
            <div className='pagination'>
                <div className='d-flex'>
                    {products?.prev_page_url ?
                        <div onClick={() => { getProducts(products?.prev_page_url) }} className="circle">
                            <span>&laquo;</span>
                        </div>
                        : null}
                    {products?.links?.map((link, i) => {
                        let index = products.links.findIndex(x => x.active === true);
                        if (products.links.length > 5) {
                            if (i != 0 && i != (products.links.length - 1) && i < (index + 5) && i >= (index - 1)) {
                                if (link.url && link.label != "Next &raquo;" && link.label != "&laquo; Previous") {
                                    return (
                                        <div onClick={() => { getProducts(link.url) }} key={i} className={link.active ? "circle active " : "circle"}>
                                            <span>{link.label}</span>
                                        </div>
                                    )
                                }
                            }
                        } else {
                            if (link.url && link.label != "Next &raquo;" && link.label != "&laquo; Previous") {
                                return (
                                    <div onClick={() => { getProducts(link.url) }} key={i} className={link.active ? "circle active " : "circle"}>
                                        <span>{link.label}</span>
                                    </div>
                                )
                            }
                        }
                    })}
                    {products?.next_page_url ?
                        <div onClick={() => { getProducts(products?.next_page_url) }} className="circle">
                            <span>&raquo;</span>
                        </div>
                        : null}
                </div>
            </div>
        </div>
    )
}

export default Products